import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import ListKunjunganPerGroup from "./listKunjunganByGroup";
import { useDispatch, useSelector } from "react-redux";
import { Dna, Watch } from "react-loader-spinner";
import { Label } from "reactstrap";
import ReactPaginate from "react-paginate";
import { getGroupKunjunganByCalonNasabah } from "stores";
import { closeGroupManual } from "stores";

function GroupCalonNasabah(data) {
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  const auth = useSelector((state) => state.authReducer);
  const [listGroup, setListGroup] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [idGroupNasabah, setIdGroupNasabah] = React.useState("");

  //   const [searchText, setSearchText] = React.useState("");
  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_NASABAH", data: true });
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_KUNJUNGAN_BY_GROUP", data: false });
    setIdGroupNasabah(val.idGroupKunjungan);
  };

  //   const handleFilterChange = () => {
  //     setIsLoading(true);
  //     setPage(0);
  //     getAllCalonNasabah(dispatch, {
  //       page: page + 1,
  //       skip: totalPerHalaman,
  //       cari: searchText,
  //     })
  //       .then((response) => {
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         setIsLoading(false);
  //         Swal.fire({
  //           icon: "error",
  //           title: "Error",
  //           text: "Terjadi kesalahan saat memuat data.",
  //         });
  //       });
  //   };

  //   const handleKeyDown = (e) => {
  //     if (e.key === "Enter") {
  //       handleFilterChange();
  //     }
  //   };

  //   const handleSearch = (e) => {
  //     setSearchText(e.target.value);
  //   };

  //   const handleClearSearch = () => {
  //     setSearchText("");
  //   };

  //   const handleDetailsClick = (val) => {
  //     dispatch({ type: "SET_DETAIL_NASABAH", data: false });
  //     // dispatch({ type: "SET_DETAIL_PENGAJUAN", data: val });
  //   };

  const submitCLoseGroup = (idCalonNasabah, idGroupKunjungan) => {
    Swal.fire({
      title: "Masukkan keterangan",
      input: "textarea",
      // inputLabel: "Keterangan",
      inputPlaceholder:
        "Tulis alasan atau keterangan penutupan group kunjungan...",
      inputAttributes: {
        "aria-label": "Tulis keterangan di sini",
      },
      showCancelButton: true,
      confirmButtonText: "Lanjut",
      cancelButtonText: "Batal",
      preConfirm: (keterangan) => {
        if (!keterangan || keterangan.trim() === "") {
          Swal.showValidationMessage("Keterangan tidak boleh kosong!");
        }
        return keterangan;
      },
    }).then((resultInput) => {
      if (resultInput.isConfirmed) {
        const keterangan = resultInput.value;

        Swal.fire({
          title: "Apakah anda yakin ingin mengakhiri group kunjungan ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, akhiri!",
          cancelButtonText: "Batal",
        }).then((resultConfirm) => {
          if (resultConfirm.isConfirmed) {
            closeGroupManual({ idGroupKunjungan, idCalonNasabah, keterangan })
              .then((response) => {
                if (response.data.status === 200) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  getGroupKunjunganByCalonNasabah(dispatch, {
                    page: page + 1,
                    limit: totalPerHalaman,
                    idCalonNasabah,
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: response.data.message,
                  });
                }
              })
              .catch((error) => {
                console.error("ERRORRRR", error);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Terjadi kesalahan saat memproses permintaan.",
                });
              });
          }
        });
      }
    });
  };

  React.useEffect(() => {
    if (korcab.groupKujunganById.docs) {
      let tmp = korcab.groupKujunganById.docs.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center">
              {/* TOMBOL DETAIL */}
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-info-${val._id}`}>
                    Detail Group Kunjungan
                  </Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#E0F2FE", // Soft Blue
                    border: "1px solid #BAE6FD",
                    color: "#0369A1",
                    transition: "all 0.2s ease",
                    marginTop: 5,
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#0369A1";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#E0F2FE";
                    e.currentTarget.style.color = "#0369A1";
                  }}
                  onClick={() => handleDetailsClick(val)}
                >
                  <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>

              {/* TOMBOL AKHIRI GROUP (ROLE BASED) */}
              {(auth.role === "area manager" ||
                auth.role === "super admin" ||
                auth.role === "admin" ||
                auth.role === "koordinator wilayah" ||
                auth.role === "supervisor") && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-ban-${val._id}`}>
                      Akhiri Group
                    </Tooltip>
                  }
                >
                  <Button
                    className="ml-2 btn-icon d-flex align-items-center justify-content-center shadow-sm"
                    disabled={val.statusKunjungan === "Done"}
                    style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "10px",
                      backgroundColor:
                        val.statusKunjungan === "Done" ? "#F1F5F9" : "#FFE4E6", // Soft Red
                      border:
                        val.statusKunjungan === "Done"
                          ? "1px solid #E2E8F0"
                          : "1px solid #FECDD3",
                      color:
                        val.statusKunjungan === "Done" ? "#94A3B8" : "#E11D48",
                      transition: "all 0.2s ease",
                      marginTop: 5,
                      cursor:
                        val.statusKunjungan === "Done"
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onMouseOver={(e) => {
                      if (val.statusKunjungan !== "Done") {
                        e.currentTarget.style.backgroundColor = "#E11D48";
                        e.currentTarget.style.color = "#ffffff";
                      }
                    }}
                    onMouseOut={(e) => {
                      if (val.statusKunjungan !== "Done") {
                        e.currentTarget.style.backgroundColor = "#FFE4E6";
                        e.currentTarget.style.color = "#E11D48";
                      }
                    }}
                    onClick={() =>
                      submitCLoseGroup(val.idCalonNasabah, val.idGroupKunjungan)
                    }
                  >
                    <i
                      className="fas fa-power-off"
                      style={{ fontSize: "14px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          ),
        };
      });
      setListGroup(tmp);
    }
  }, [korcab.groupKujunganById]);

  const InfoBox = ({
    label,
    value,
    col = 6,
    isPrimary = false,
    color = "black",
  }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted fw-bold d-block mb-1"
        style={{
          fontSize: "10px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </label>
      <div
        className={`p-2 rounded-lg ${isPrimary ? "bg-light border" : ""}`}
        style={{
          fontSize: "14px",
          fontWeight: isPrimary ? "800" : "600",
          color: color,
          minHeight: "38px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {value || "-"}
      </div>
    </Col>
  );

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusStyle = (status) => {
    switch (status) {
      case "Progress":
        return {
          fontWeight: "bold",
          backgroundColor: "#FDE5DD",
          textColor: "#F85317",
        };
      case "Done":
        return {
          fontWeight: "bold",
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F1F5F9",
        minHeight: "50px",
        borderTop: "1px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "11px",
        color: "#475569",
        textTransform: "uppercase",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
        "&:hover": {
          backgroundColor: "#F8FAFC",
          cursor: "pointer",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        justifyContent: "center",
        color: "#1E293B",
      },
    },
  };

  const colGroupKunjungan = [
    {
      name: "NO",
      width: "70px",
      center: true,
      selector: (row, index) => index + korcab.groupKujunganById.pagingCounter,
      style: { fontWeight: "bold", borderRight: "1px solid #F1F5F9" },
    },
    {
      name: "ID GROUP",
      minWidth: "180px",
      selector: (row) => row.idGroupKunjungan,
      cell: (row) => (
        <span className="fw-800 text-primary">{row.idGroupKunjungan}</span>
      ),
    },
    {
      name: "ID PINJAMAN",
      minWidth: "150px",
      selector: (row) => row.loan || "-",
      cell: (row) => (
        <span className="badge bg-light text-dark border">
          {row.id_pinjaman || "-"}
        </span>
      ),
    },
    {
      name: "KATEGORI",
      minWidth: "150px",
      cell: (row) => (
        <div className="text-center">
          <div className="fw-bold" style={{ fontSize: "12px" }}>
            {row.kategoriNasabah === "konvensional"
              ? "Konvensional"
              : "Syariah"}
          </div>
          <small className="text-muted text-capitalize">
            {row.kategoriTujuanPenggunaan}
          </small>
        </div>
      ),
    },
    {
      name: "MARKETING",
      minWidth: "200px",
      cell: (row) => (
        <div className="text-center">
          <div className="fw-bold text-dark">{row.marketing.nama}</div>
          <div className="small text-muted">{row.marketing.nopeg}</div>
        </div>
      ),
    },
    {
      name: "STATUS",
      minWidth: "180px",
      cell: (row) => {
        const statusStyle = getStatusStyle(row.statusKunjungan);
        return (
          <span
            style={{
              fontWeight: "800",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "8px",
              fontSize: "11px",
              textTransform: "uppercase",
              display: "inline-block",
              minWidth: "100px",
              textAlign: "center",
              border: `1px solid ${statusStyle.textColor}20`, // Border tipis transparan
            }}
          >
            {row.statusKunjungan}
          </span>
        );
      },
    },
    {
      name: "AKSI",
      width: "100px",
      center: true,
      cell: (row) => (
        <div className="d-flex justify-content-center">{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getGroupKunjunganByCalonNasabah(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      idCalonNasabah: data.data,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      {korcab.modalKunjunganByGroup ? (
        <Container fluid className="py-4">
          {/* TOP BAR: Back Button & Title */}
          <div className="d-flex align-items-center mb-4">
            <Button
              className="btn-icon shadow-sm mr-3 d-flex align-items-center justify-content-center"
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                backgroundColor: "#fff",
                border: "1px solid #e2e8f0",
                color: "#E63946",
              }}
              onClick={handleClick}
            >
              <i className="fas fa-arrow-left"></i>
            </Button>
            <div>
              <h4
                className="fw-800 text-dark m-0"
                style={{ letterSpacing: "1px" }}
              >
                DETAIL NASABAH
              </h4>
              <p className="text-muted small m-0">
                Informasi profil dan riwayat kunjungan nasabah.
              </p>
            </div>
          </div>

          <Row>
            {/* CARD 1: INFORMASI PROFIL */}
            <Col md="12" className="mb-4">
              <Card
                className="border-0 shadow-sm"
                style={{ borderRadius: "20px" }}
              >
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-4">
                    <div className="bg-light-blue p-3 rounded-lg mr-3">
                      <i className="fas fa-user-tie text-primary fa-lg"></i>
                    </div>
                    <h5 className="fw-800 m-0">Profil Lengkap</h5>
                  </div>

                  <Row>
                    <InfoBox
                      label="Nama Lengkap"
                      value={data.value.namaNasabah}
                      isPrimary
                    />
                    <InfoBox
                      label="NIK / No. Identitas"
                      value={data.value.nik}
                    />
                    <InfoBox
                      label="Nomor Handphone"
                      value={data.value.noHp}
                      color="#116D6E"
                    />
                    <InfoBox
                      label="Tanggal Lahir"
                      value={moment(data.value.tglLahir).format("DD MMMM YYYY")}
                    />
                    <InfoBox
                      label="Kategori Nasabah"
                      value={
                        data.value.kategoriNasabah === "1"
                          ? "PNS Biasa"
                          : data.value.kategoriNasabah === "2"
                            ? "PNS Prapurna Bakti"
                            : data.value.kategoriNasabah === "3"
                              ? "Pensiunan"
                              : data.value.kategoriNasabah === "4"
                                ? "PRA THT"
                                : "KPS (Kredit Pensiunan)"
                      }
                    />
                    <InfoBox
                      label="Tipe Kunjungan"
                      value={data.value.typeKunjungan}
                    />
                    <InfoBox
                      label="Alamat Domisili"
                      value={data.value.alamat}
                      col={12}
                    />
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* CARD 2: LIST KUNJUNGAN */}
            <Col md="12">
              <Card
                className="border-0 shadow-sm"
                style={{ borderRadius: "20px" }}
              >
                <Card.Header className="bg-white border-0 pt-4 px-4">
                  <div className="d-flex align-items-center">
                    <div className="bg-light-red p-3 rounded-lg mr-3">
                      <i className="fas fa-history text-danger fa-lg"></i>
                    </div>
                    <h5 className="fw-800 m-0">RIWAYAT KUNJUNGAN</h5>
                  </div>
                </Card.Header>
                <Card.Body className="px-4 pb-4">
                  {isLoading ? (
                    <div className="text-center py-5">
                      <l-quantum
                        size="50"
                        speed="2.75"
                        color="#E63946"
                      ></l-quantum>
                      <p className="mt-3 text-muted fw-600">
                        Mengambil riwayat...
                      </p>
                    </div>
                  ) : listGroup.length > 0 ? (
                    <div className="table-responsive-custom">
                      <DataTable
                        columns={colGroupKunjungan}
                        data={listGroup}
                        customStyles={customStyles}
                        pagination={false}
                      />

                      {/* PAGINATION AREA */}
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pt-4 border-top">
                        <div className="d-flex align-items-center mb-3 mb-md-0">
                          <span className="text-muted small fw-bold mr-2">
                            Tampilkan
                          </span>
                          <div style={{ width: "100px" }}>
                            <Select
                              classNamePrefix="react-select"
                              value={options.find(
                                (opt) => opt.value === totalPerHalaman,
                              )}
                              onChange={handlePageSizeChange}
                              options={options}
                              menuPlacement="top"
                            />
                          </div>
                        </div>

                        <ReactPaginate
                          forcePage={page}
                          containerClassName="pagination mb-0"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          activeClassName="active"
                          pageCount={korcab.groupKujunganById.totalPages || 1}
                          onPageChange={(val) => setPage(val.selected)}
                          nextLabel=">"
                          previousLabel="<"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <img
                        src={require("assets/img/sorry.jpg").default}
                        alt="Empty"
                        style={{ maxWidth: "150px", opacity: "0.7" }}
                      />
                      <p className="mt-3 fw-bold text-muted">
                        Belum ada riwayat kunjungan.
                      </p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <style>{`
    .fw-800 { font-weight: 800; }
    .bg-light-blue { background-color: #E0F2FE; }
    .bg-light-red { background-color: #FFE4E6; }
    .rounded-lg { border-radius: 12px; }
  `}</style>
        </Container>
      ) : (
        <>
          <ListKunjunganPerGroup data={idGroupNasabah} />
        </>
      )}
    </>
  );
}

export default GroupCalonNasabah;
